var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"fill-current text-white",attrs:{"src":"https://cdn.discordapp.com/attachments/746242308084858900/826320989340172289/Group_6.png","alt":"Logo","width":"200","draggable":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }